/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Team • Over 50 medlemmer',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Team • Over 50 medlemmer, inklusive dig',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Team • 1 medlem} other {Team • {0} medlemmer}}',
  'fabric.elements.mentions.team.member.count.including.you':
    '{0, plural, one {Team • 1 medlem, inklusive dig} other {Team • {0} medlemmer, inklusive dig}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Har brug for adgang til Confluence',
  'fabric.mention.error.defaultAction': 'Prøv igen om nogle sekunder',
  'fabric.mention.error.defaultHeadline': 'Noget gik galt',
  'fabric.mention.error.differentText': 'Prøv at indtaste en anden tekst',
  'fabric.mention.error.loginAgain': 'Prøv at logge ud og derefter ind igen',
  'fabric.mention.noAccess.label': 'Ingen adgang',
  'fabric.mention.noAccess.warning': '{name} får ikke besked, da personen ikke har adgang',
  'fabric.mention.unknow.user.error': 'Ukendt bruger {userId}',
};
